import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject } from '@digibricks/core';
export var UnixTimestamp = /*#__PURE__*/function (_ValueObject) {
  _inherits(UnixTimestamp, _ValueObject);

  var _super = _createSuper(UnixTimestamp);

  function UnixTimestamp() {
    _classCallCheck(this, UnixTimestamp);

    return _super.apply(this, arguments);
  }

  _createClass(UnixTimestamp, null, [{
    key: "parseMilliseconds",
    value: function parseMilliseconds(value) {
      if (value == null || value === '') return null;
      var timestamp = Number(value);
      if (!Number.isFinite(timestamp) || timestamp <= 0) return null;
      var milliseconds = timestamp < 1e12 ? timestamp * 1000 : timestamp;
      return milliseconds <= 8.64e15 ? milliseconds : null;
    }
  }, {
    key: "now",
    value: function now() {
      return Date.now().toString();
    }
  }, {
    key: "calculateTimestampDuration",
    value: function calculateTimestampDuration(startTime, endTime) {
      var startTimeInSecond = this.isInSecondType(startTime) ? parseInt(startTime) : parseInt(startTime) / 1000;
      var endTimeInSecond = this.isInSecondType(endTime) ? parseInt(endTime) : parseInt(endTime) / 1000;
      var durationInSeconds = endTimeInSecond - startTimeInSecond;
      var days = Math.floor(durationInSeconds / (24 * 60 * 60));
      var hours = Math.floor(durationInSeconds % (24 * 60 * 60) / (60 * 60));
      var minutes = Math.floor(durationInSeconds % (60 * 60) / 60);
      var seconds = durationInSeconds % 60;
      return [days, hours, minutes, seconds];
    }
  }, {
    key: "toMillisecond",
    value: function toMillisecond(unixTimestamp) {
      return (parseInt(unixTimestamp) * 1000).toString();
    }
  }, {
    key: "calculateFromDuration",
    value: function calculateFromDuration(originalStartTime, durationInMinute) {
      var startTime = new Date(parseInt(originalStartTime)).getTime();

      if (!this.isInSecondType(originalStartTime.toString())) {
        startTime = startTime / 1000;
      } // Convert duration in minutes to seconds


      var durationInSeconds = durationInMinute * 60; // Add duration to start timestamp

      var endTimestamp = startTime + durationInSeconds;
      return endTimestamp.toString();
    }
  }, {
    key: "isInSecondType",
    value: function isInSecondType(timestamp) {
      var trimmedTimestamp = timestamp.trim();
      return trimmedTimestamp.length === 10 && /^\d+$/.test(trimmedTimestamp);
    }
  }, {
    key: "floorToNearestMinute",
    value: function floorToNearestMinute(timestamp) {
      // Parse the input timestamp (assuming it's in milliseconds since Unix epoch)
      var parsedTimestamp = parseInt(timestamp); // Floor to the nearest minute (in milliseconds)

      var flooredTimestamp = Math.floor(parsedTimestamp / 60000) * 60000; // Return the floored timestamp as a string

      return flooredTimestamp.toString();
    }
  }]);

  return UnixTimestamp;
}(ValueObject);